// Module
var code = "<section class=\"cr-filters-container {{ ::$ctrl.customClass }}\" data-global-qa-id=\"manage-filters\"> <div ng-transclude></div> </section> ";
// Exports
export default code;